export default "__VITE_ASSET__709607de__"